module.exports = __webpack_public_path__ + "static/img/3.205a7c78.jpg";